import { render, staticRenderFns } from "./FeedbackForPartner.vue?vue&type=template&id=3ab0725e"
import script from "./FeedbackForPartner.vue?vue&type=script&lang=js"
export * from "./FeedbackForPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports